export default __webpack_public_path__ + "static/media/cc_white.1c6c0974.jpg";